import { render, staticRenderFns } from "./itemMasterDetailView.vue?vue&type=template&id=41bf4b41&scoped=true&"
import script from "./itemMasterDetailView.vue?vue&type=script&lang=js&"
export * from "./itemMasterDetailView.vue?vue&type=script&lang=js&"
import style0 from "./itemMasterDetailView.vue?vue&type=style&index=0&id=41bf4b41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bf4b41",
  null
  
)

export default component.exports